/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { kpiDataLoadingAction, kpiDataUpdateAction, kpiDataErrorAction } from './kpiDailySlice'
import { deviceListErrorAction, deviceListLoadingAction, deviceListUpdateAction } from './deviceListSlice'
import { allAlarmDataErrorAction, allAlarmDataLoadingAction, allAlarmDataUpdateAction } from './allAlarmsSlice'
import { topIssuesLoadingAction, topIssuesUpdateAction, topIssuesErrorAction } from './topIssuesSlice'
import * as DataCompletenessService from '../services/dataCompletenessService'
import * as DeviceListService from '../services/deviceListService'
import * as SearchAssetBySerialNumberService from '../services/searchAssetBySerialNumber'
import * as AllActiveIssuesService from '../services/allAlarmService'
import * as TopIssuesService from '../services/topIssuesService'
import * as ThirtyDayService from '../services/thirtyDayService'
import { type AllAlarmDetails } from './allAlarmsSlice'
import { thirtyDayLoadingAction, thirtyDayUpdateAction, thirtyDayErrorAction } from './thirtyDaySlice'

export const fetchKpiDailyData =
  (tenantId: string) => async (dispatch: any) => {
    dispatch(kpiDataLoadingAction())
    void DataCompletenessService.getDataCompletenessKpis(
      tenantId,
      (kpiData, httpStatus) => {
        dispatch(kpiDataUpdateAction({ kpiData, httpStatus }))
      },
      (errorMessage, httpStatus) => {
        dispatch(kpiDataErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const fetchDeviceList =
  (page: any, size: any, sortdir: any, sortfield: any, tenantId: string) =>
    async (dispatch: any): Promise<void> => {
      dispatch(deviceListLoadingAction())

      void DeviceListService.getDeviceList(
        page,
        size,
        sortdir,
        sortfield,
        tenantId,
        (deviceList, httpStatus) => {
          dispatch(
            deviceListUpdateAction({
              data: deviceList.assets,
              count: deviceList.total_count,
              httpStatus
            })
          )
        },
        (errorMessage, httpStatus) => {
          dispatch(deviceListErrorAction({ errorMessage, httpStatus }))
        }
      )
    }

export const fetchAssetBySearchValue =
  (searchVal: string, tenantId: string, page: number, size: number, sortfield: string, sortdir: string) =>
    async (dispatch: any): Promise<void> => {
      dispatch(deviceListLoadingAction())

      void SearchAssetBySerialNumberService.getAssetBySearchValue(
        searchVal,
        tenantId,
        page,
        size,
        sortfield,
        sortdir,
        (assetList, httpStatus) => {
          dispatch(
            deviceListUpdateAction({
              data: assetList.assets,
              count: assetList.total_count,
              httpStatus
            })
          )
        },
        (errorMessage, httpStatus) => {
          dispatch(deviceListErrorAction({ errorMessage, httpStatus }))
        }
      )
    }

export const fetchAllActiveAlarms = (page: number, size: number, sortdir: string, sortfield: string, tenantId: string) => async (dispatch: any): Promise<void> => {
  dispatch(allAlarmDataLoadingAction())

  void AllActiveIssuesService.getAllAlarms(
    page, size, sortdir, sortfield, tenantId,
    (allAlarmData, httpStatus) => {
      dispatch(
        allAlarmDataUpdateAction({
          data: allAlarmData.alarms,
          count: allAlarmData.totalCount,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(allAlarmDataErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchTopIssuesData = (tenant: string) => async (dispatch: any) => {
  dispatch(topIssuesLoadingAction())

  void TopIssuesService.getTopIssues(
    tenant,
    (topIssues: AllAlarmDetails) => {
      const fatals = topIssues.alarms.filter(item => item.severity === 'critical')
      const schedule = topIssues.alarms.filter(item => item.severity === 'Schedule')
      const noData = topIssues.alarms.filter(item => item.severity === 'noData')
      dispatch(topIssuesUpdateAction([schedule.length, noData.length, fatals.length]))
    },
    (errorMessage) => {
      dispatch(topIssuesErrorAction(errorMessage))
    }
  )
}

function parseData (jsonData: any[]) {
  const dateMap = new Map()

  jsonData.forEach((entry) => {
    const timestamp = entry.timestamp
    const kpiValue = entry.kpi_value

    const dateKey = new Date(timestamp).toISOString().split('T')[0]

    if (!dateMap.has(dateKey) || new Date(timestamp) > new Date(dateMap.get(dateKey).timestamp)) {
      dateMap.set(dateKey, { timestamp, kpiValue })
    }
  })

  const latestValues = Array.from(dateMap.values())
  latestValues.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())

  const timestamps = latestValues.map((entry) => entry.timestamp)
  const kpiValues = latestValues.map((entry) => entry.kpiValue)

  return { timestamps, kpiValues }
}

export const fetchThirtyDayData =
  (tenant: string, from: string, to: string) => async (dispatch: any) => {
    dispatch(thirtyDayLoadingAction())
    void ThirtyDayService.getThirtyDayData(
      tenant,
      from,
      to,
      (thirtyDayData, httpStatus) => {
        const parsedData = parseData(thirtyDayData)
        dispatch(thirtyDayUpdateAction({ data: parsedData, httpStatus }))
      },
      (errorMessage, httpStatus) => {
        dispatch(thirtyDayErrorAction({ errorMessage, httpStatus }))
      }
    )
  }
